import type { IProfileDto, IUserDto } from '@web/entities/user/api/types'
import type { IProfile, IUser } from '@web/entities/user/model/types'

const getFullName = (
  firstName: string | null,
  lastName: string,
  middleName: string | null
) => {
  const firstInitial = firstName ? `${firstName[0]}.` : ''
  const middleInitial = middleName ? `${middleName[0]}.` : ''

  return `${lastName} ${firstInitial}${middleInitial}`.trim()
}

export const toProfile = (dto: IProfileDto): IProfile => ({
  id: dto.id,
  email: dto.email,
  avatarImageId: dto.avatarImageId,
  firstName: dto.firstName,
  lastName: dto.lastName,
  role: dto.type,
  blocked: dto.blocked,
  middleName: dto.middleName,
  fullName: getFullName(dto.firstName, dto.lastName, dto.middleName)
})

export const toUser = (dto: IUserDto): IUser => ({
  ...dto,
  role: dto.type,
  fullName: getFullName(dto.firstName, dto.lastName, dto.middleName)
})
